
import { Options, Vue } from "vue-class-component";

@Options({
  data() {
    return {
      images: {
        one: require("@images/one.png"),
        two_left: require("@images/two-f-r.png"),
        three: require("@images/three.png"),
        indexIcons: [
          {
            title: "境外路由优化",
            src: require("@images/index-icon2.png"),
          },
          {
            title: "设备访问授权",
            src: require("@images/index-icon3.png"),
          },
          {
            title: "匿名浏览器指纹",
            src: require("@images/index-icon4.png"),
          },
          {
            title: "全链路加密",
            src: require("@images/index-icon5.png"),
          },
          {
            title: "账号管理授权",
            src: require("@images/index-icon7.png"),
          },
          {
            title: "独享VPS环境+纯净IP",
            src: require("@images/index-icon8.png"),
          },
        ],
      },
    };
  },
  methods: {
    gotoRegister() {
      this.$router.push("/register");
    },
  },
})
export default class Header extends Vue {}
